import BaseEntity  from '@/core/misc/BaseEntity';
import Title_ru_RU from '@/core/misc/decorators/Title_ru_RU';
import TYPES       from '@/core/services/Changelogs/types';
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

@Title_ru_RU_Class('Производитель')
class Manufacturer extends BaseEntity {

  static Events = {
    Created: 'manufacturer:created',
    Updated: 'manufacturer:updated',
    Deleted: 'manufacturer:deleted',
  } as const;

  @Title_ru_RU('Название', TYPES.STRING)
  public name: string;

  static fromServer(data: any, result = new Manufacturer()): Manufacturer {
    super.fromServer(data, result);

    return result;
  }

  toString(): string {
    return this.name;
  }
}

export default Manufacturer;
